// Auto-generated file: Do not modify directly. Changes may be overwritten. Version: 1.3.0.
// Pre-formatted for Stitches — pass directly to loadTheme without runtime formatting.

/*
 * Following tokens have been deprecated in version 1.3.0, please update your theme:
 *
 * Interactive/Focus has been split into two separate tokens. Please define 'Interactive/Focus Inner' and 'Interactive/Focus Outer' instead.
 * 'Interactive/Background Default' is deprecated. Please use 'Input/Background Default' instead.
 * 'Interactive/Background Disabled' is deprecated. Please use 'Input/Background Disabled' instead.
 * 'Interactive/Background Hovered' is deprecated. Please use 'Input/Background Hovered' instead.
 * 'Interactive/Background Pressed' is deprecated. Please use 'Input/Background Pressed' instead.
 * 'Interactive/Border Default' is deprecated. Please use 'Input/Border Default' instead.
 * 'Interactive/Border Hovered' is deprecated. Please use 'Input/Border Hovered' instead.
 * 'Interactive/Border Disabled' is deprecated. Please use 'Input/Border Disabled' instead.
 * 'Interactive/Border Critical Default' is deprecated. Please use 'Input/Border Critical' instead.
 * 'Pill' is deprecated. Please use 'Circle' instead.
 */

import type { GDSTheme, GDSStitchesFormattedTheme } from '../theme-types';

export const archetypeLightStitchesTheme: GDSStitchesFormattedTheme = {
  rem: {
    space: {
      none: '0',
      quarter: '0.25rem',
      half: '0.5rem',
      threeQuarters: '0.75rem',
      one: '1rem',
      oneAndHalf: '1.5rem',
      two: '2rem',
      twoAndHalf: '2.5rem',
      three: '3rem',
      four: '4rem',
      five: '5rem',
      eighth: '0.125rem',
      headingOne: '$none',
      headingTwo: '$none',
      headingThree: '$none',
      headingFour: '$none',
      subtitleOne: '$none',
      subtitleTwo: '$none',
      buttonOne: '$none',
      buttonTwo: '$none',
      label: '$none',
      overline: '$none',
      caption: '$none',
      tab: '$none',
      minusQuarter: '-0.25rem',
      minusHalf: '-0.5rem',
      minusThreeQuarters: '-0.75rem',
      minusOne: '-1rem',
      minusOneAndHalf: '-1.5rem',
      minusTwo: '-2rem',
      minusTwoAndHalf: '-2.5rem',
      minusThree: '-3rem',
      minusFour: '-4rem',
      minusFive: '-5rem',
      minusEighth: '-0.125rem',
    },
    sizes: {
      none: '0',
      quarter: '0.25rem',
      half: '0.5rem',
      threeQuarters: '0.75rem',
      one: '1rem',
      oneAndHalf: '1.5rem',
      two: '2rem',
      twoAndHalf: '2.5rem',
      three: '3rem',
      four: '4rem',
      five: '5rem',
      eighth: '0.125rem',
      headingOne: '$none',
      headingTwo: '$none',
      headingThree: '$none',
      headingFour: '$none',
      subtitleOne: '$none',
      subtitleTwo: '$none',
      buttonOne: '$none',
      buttonTwo: '$none',
      label: '$none',
      overline: '$none',
      caption: '$none',
      tab: '$none',
    },
    fontSizes: {
      headingOne: '2rem',
      headingTwo: '1.5rem',
      headingThree: '1.25rem',
      headingFour: '1.125rem',
      subtitleOne: '1rem',
      subtitleTwo: '0.875rem',
      bodyOne: '1rem',
      bodyOneSecondary: '1rem',
      bodyTwo: '0.875rem',
      bodyTwoSecondary: '0.875rem',
      buttonOne: '1rem',
      buttonTwo: '0.875rem',
      label: '0.75rem',
      overline: '0.75rem',
      caption: '0.75rem',
      tab: '0.625rem',
    },
    lineHeights: {
      headingOne: '2.5rem',
      headingTwo: '2rem',
      headingThree: '1.75rem',
      headingFour: '1.5rem',
      subtitleOne: '1.5rem',
      subtitleTwo: '1.25rem',
      bodyOne: '1.5rem',
      bodyOneSecondary: '1.5rem',
      bodyTwo: '1.25rem',
      bodyTwoSecondary: '1.25rem',
      buttonOne: '1.5rem',
      buttonTwo: '1.25rem',
      label: '1rem',
      overline: '1rem',
      caption: '1rem',
      tab: '0.75rem',
    },
  },
  px: {
    space: {
      none: '0',
      quarter: '4px',
      half: '8px',
      threeQuarters: '12px',
      one: '16px',
      oneAndHalf: '24px',
      two: '32px',
      twoAndHalf: '40px',
      three: '48px',
      four: '64px',
      five: '80px',
      eighth: '2px',
      headingOne: '$none',
      headingTwo: '$none',
      headingThree: '$none',
      headingFour: '$none',
      subtitleOne: '$none',
      subtitleTwo: '$none',
      bodyOne: '$half',
      bodyOneSecondary: '$half',
      bodyTwo: '$half',
      bodyTwoSecondary: '$half',
      buttonOne: '$none',
      buttonTwo: '$none',
      label: '$none',
      overline: '$none',
      caption: '$none',
      tab: '$none',
      minusQuarter: '-4px',
      minusHalf: '-8px',
      minusThreeQuarters: '-12px',
      minusOne: '-16px',
      minusOneAndHalf: '-24px',
      minusTwo: '-32px',
      minusTwoAndHalf: '-40px',
      minusThree: '-48px',
      minusFour: '-64px',
      minusFive: '-80px',
      minusEighth: '-2px',
    },
    sizes: {
      none: '0',
      quarter: '4px',
      half: '8px',
      threeQuarters: '12px',
      one: '16px',
      oneAndHalf: '24px',
      two: '32px',
      twoAndHalf: '40px',
      three: '48px',
      four: '64px',
      five: '80px',
      eighth: '2px',
      headingOne: '$none',
      headingTwo: '$none',
      headingThree: '$none',
      headingFour: '$none',
      subtitleOne: '$none',
      subtitleTwo: '$none',
      bodyOne: '$half',
      bodyOneSecondary: '$half',
      bodyTwo: '$half',
      bodyTwoSecondary: '$half',
      buttonOne: '$none',
      buttonTwo: '$none',
      label: '$none',
      overline: '$none',
      caption: '$none',
      tab: '$none',
    },
    fontSizes: {
      headingOne: '32px',
      headingTwo: '24px',
      headingThree: '20px',
      headingFour: '18px',
      subtitleOne: '16px',
      subtitleTwo: '14px',
      bodyOne: '16px',
      bodyOneSecondary: '$bodyOne',
      bodyTwo: '14px',
      bodyTwoSecondary: '$bodyTwo',
      buttonOne: '16px',
      buttonTwo: '14px',
      label: '12px',
      overline: '12px',
      caption: '12px',
      tab: '10px',
    },
    lineHeights: {
      headingOne: '40px',
      headingTwo: '32px',
      headingThree: '28px',
      headingFour: '24px',
      subtitleOne: '24px',
      subtitleTwo: '20px',
      bodyOne: '24px',
      bodyOneSecondary: '$bodyOne',
      bodyTwo: '20px',
      bodyTwoSecondary: '$bodyTwo',
      buttonOne: '24px',
      buttonTwo: '20px',
      label: '16px',
      overline: '16px',
      caption: '16px',
      tab: '12px',
    },
  },
  colors: {
    surfaceBackgroundPrimary: '#FFFFFFFF',
    surfaceBackgroundSecondary: '#F2F2F2FF',
    surfaceBackgroundTertiary: '#E8E8E8FF',
    surfaceCardPrimary: '#F2F2F2FF',
    surfaceCardSecondary: '#FFFFFFFF',
    surfaceCardDisabled: '#D7D7D7FF',
    surfaceScreenHeaderBackground: '#E8E8E8FF',
    surfaceSkeletonShimmerBackground: '#E7E7E7FF',
    surfaceSkeletonShimmerOverlay:
      'linear-gradient(90.0deg, #FFFFFF00 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)',
    onSurfaceTextPrimary: '#1A1A1AFF',
    onSurfaceTextSubdued: '#545454FF',
    onSurfaceTextReversed: '#FFFFFFFF',
    onSurfaceTextCritical: '#DD0E0EFF',
    onSurfaceTextSuccess: '#507C03FF',
    onSurfaceTextWarning: '#C94F08FF',
    onSurfaceBorderSubdued: '#EFEFEFFF',
    onSurfaceBorderDefault: '#C2C2C2FF',
    onSurfaceBorderCard: '#EBEBEBFF',
    onSurfaceIconPrimary: '#636363FF',
    interactiveActionPrimary: '#1A1A1AFF',
    interactiveActionHovered: '#000000FF',
    interactiveActionPressed: '#1A1A1AFF',
    interactiveActionSubdued: '#66686BFF',
    interactiveActionDisabled: '#D6D6D6FF',
    interactiveIconDefault: '#FFFFFFFF',
    interactiveIconDisabled: '#949494FF',
    interactiveBackgroundDefault: '#FFFFFFFF',
    interactiveBackgroundDisabled: '#E8EAEDFF',
    interactiveBackgroundHovered: '#F8F8F8FF',
    interactiveBackgroundPressed: '#F0F0F0FF',
    interactiveBorderDefault: '#949494FF',
    interactiveBorderHovered: '#4E4E4EFF',
    interactiveBorderDisabled: '#D6D6D6FF',
    interactiveBorderCriticalDefault: '#DD0E0EFF',
    interactiveFocusInner: '#1A1A1AFF',
    interactiveFocusOuter: '#1A1A1AFF',
    criticalBackgroundSubdued: '#F9E1E2FF',
    criticalBackgroundSecondary: '#FFFFFFFF',
    criticalBorderDefault: '#DD0E0EFF',
    criticalIcon: '#DD0E0EFF',
    warningBackgroundSubdued: '#FAE8D6FF',
    warningBackgroundSecondary: '#FFFFFFFF',
    warningBorderDefault: '#C94F08FF',
    warningIcon: '#C94F08FF',
    successBackgroundSubdued: '#F6FCEBFF',
    successBackgroundSecondary: '#FFFFFFFF',
    successBorderDefault: '#507C03FF',
    successIcon: '#507C03FF',
    highlightBackgroundSubdued: '#EDF8FFFF',
    highlightBackgroundSecondary: '#FFFFFFFF',
    highlightBorderDefault: '#2E5CDFFF',
    highlightIcon: '#2E5CDFFF',
    decorativeBrandPrimaryDarkest: '#1A1A1AFF',
    decorativeBrandPrimaryDark: '#4B4B4BFF',
    decorativeBrandPrimaryDefault: '#7F7F7FFF',
    decorativeBrandPrimaryBright: '#B9B9B9FF',
    decorativeBrandPrimaryBrightest: '#ECECECFF',
    decorativeBrandPrimaryPastel: '#FAFAFAFF',
    decorativeBrandSecondaryDarkest: '#1A1A1AFF',
    decorativeBrandSecondaryDark: '#4B4B4BFF',
    decorativeBrandSecondaryDefault: '#7F7F7FFF',
    decorativeBrandSecondaryBright: '#B9B9B9FF',
    decorativeBrandSecondaryBrightest: '#ECECECFF',
    decorativeBrandSecondaryPastel: '#FAFAFAFF',
    decorativeBrandTertiaryDarkest: '#1A1A1AFF',
    decorativeBrandTertiaryDark: '#4B4B4BFF',
    decorativeBrandTertiaryDefault: '#7F7F7FFF',
    decorativeBrandTertiaryBright: '#B9B9B9FF',
    decorativeBrandTertiaryBrightest: '#ECECECFF',
    decorativeBrandTertiaryPastel: '#FAFAFAFF',
    primaryBackgroundDefault: '#1A1A1AFF',
    primaryBackgroundHovered: '#000000FF',
    primaryBackgroundPressed: '#1A1A1AFF',
    primaryBackgroundCriticalDefault: '#DD0E0EFF',
    primaryBackgroundCriticalHovered: '#B51414FF',
    primaryBackgroundCriticalPressed: '#DD0E0EFF',
    primaryTextDefault: '#FFFFFFFF',
    primaryTextCriticalDefault: '#FFFFFFFF',
    secondaryBackgroundDefault: '#FFFFFFFF',
    secondaryBackgroundHovered: '#DCDCDCFF',
    secondaryBackgroundPressed: '#F0F0F0FF',
    secondaryTextDefault: '#1A1A1AFF',
    secondaryTextHovered: '#1A1A1AFF',
    secondaryBorderDefault: '#1A1A1AFF',
    tertiaryBackgroundDefault: '#FFFFFF00',
    tertiaryBackgroundHovered: '#DCDCDCFF',
    tertiaryBackgroundPressed: '#F0F0F0FF',
    tertiaryTextDefault: '#1A1A1AFF',
    tertiaryTextHovered: '#1A1A1AFF',
    tertiaryBorderDefault: '#DCDCDCFF',
    inputBorderSuccess: '#507C03FF',
    inputBorderWarning: '#C94F08FF',
    inputBorderDefault: '#949494FF',
    inputBorderHovered: '#4E4E4EFF',
    inputBorderDisabled: '#D6D6D6FF',
    inputBorderCritical: '#DD0E0EFF',
    inputBackgroundDefault: '#FFFFFFFF',
    inputBackgroundDisabled: '#E8EAEDFF',
    inputBackgroundHovered: '#F8F8F8FF',
    inputBackgroundPressed: '#F0F0F0FF',
    dataVizInterfaceTrackBorder: '#959595FF',
    dataVizInterfaceTrackBackground: '#F5F5F5FF',
    dataVizSingleColorBrand: '#1A1A1AFF',
    dataVizSingleColorNeutral: '#959595FF',
    dataVizStatusCritical: '#DD0E0EFF',
    dataVizStatusWarning: '#F16501FF',
    dataVizStatusSuccess: '#0DA80AFF',
    dataVizCategoricalOne: '#1A1A1AFF',
    dataVizCategoricalTwo: '#6212E6FF',
    dataVizCategoricalThree: '#F0184CFF',
    dataVizCategoricalFour: '#2695E6FF',
    dataVizCategoricalFive: '#F16501FF',
    dataVizCategoricalSix: '#0DA80AFF',
    tagNeutralBackgroundBold: '#3B3B3BFF',
    tagNeutralBackgroundSubdued: '#E9E9E9FF',
    tagNeutralBorderBold: '#3B3B3BFF',
    tagNeutralBorderSubdued: '#E9E9E9FF',
    tagNeutralTextBold: '#FFFFFFFF',
    tagNeutralTextSubdued: '#1A1A1AFF',
    tagOneBackgroundBold: '#501CD2FF',
    tagOneBackgroundSubdued: '#EDEAF5FF',
    tagOneBorderBold: '#501CD2FF',
    tagOneBorderSubdued: '#EDEAF5FF',
    tagOneTextBold: '#FFFFFFFF',
    tagOneTextSubdued: '#1A1A1AFF',
    tagTwoBackgroundBold: '#135D03FF',
    tagTwoBackgroundSubdued: '#DEEADCFF',
    tagTwoBorderBold: '#135D03FF',
    tagTwoBorderSubdued: '#DEEADCFF',
    tagTwoTextBold: '#FFFFFFFF',
    tagTwoTextSubdued: '#1A1A1AFF',
    tagThreeBackgroundBold: '#994000FF',
    tagThreeBackgroundSubdued: '#F2EEE6FF',
    tagThreeBorderBold: '#994000FF',
    tagThreeBorderSubdued: '#F2EEE6FF',
    tagThreeTextBold: '#FFFFFFFF',
    tagThreeTextSubdued: '#1A1A1AFF',
    tagFourBackgroundBold: '#870644FF',
    tagFourBackgroundSubdued: '#F2E1F0FF',
    tagFourBorderBold: '#870644FF',
    tagFourBorderSubdued: '#F2E1F0FF',
    tagFourTextBold: '#FFFFFFFF',
    tagFourTextSubdued: '#1A1A1AFF',
    tagSuccessBackgroundBold: '#008A09FF',
    tagSuccessBackgroundSubdued: '#E3F7F0FF',
    tagSuccessBorderBold: '#008A09FF',
    tagSuccessBorderSubdued: '#E3F7F0FF',
    tagSuccessTextBold: '#FFFFFFFF',
    tagSuccessTextSubdued: '#02692BFF',
    tagWarningBackgroundBold: '#B85B0FFF',
    tagWarningBackgroundSubdued: '#FAE8D6FF',
    tagWarningBorderBold: '#B85B0FFF',
    tagWarningBorderSubdued: '#FAE8D6FF',
    tagWarningTextBold: '#FFFFFFFF',
    tagWarningTextSubdued: '#9F3703FF',
    tagCriticalBackgroundBold: '#DD0E0EFF',
    tagCriticalBackgroundSubdued: '#F9E1E2FF',
    tagCriticalBorderBold: '#DD0E0EFF',
    tagCriticalBorderSubdued: '#F9E1E2FF',
    tagCriticalTextBold: '#FFFFFFFF',
    tagCriticalTextSubdued: '#BB1111FF',
    tagInformationalBackgroundBold: '#2E5CDFFF',
    tagInformationalBackgroundSubdued: '#E8F8FFFF',
    tagInformationalBorderBold: '#2E5CDFFF',
    tagInformationalBorderSubdued: '#E8F8FFFF',
    tagInformationalTextBold: '#FFFFFFFF',
    tagInformationalTextSubdued: '#225ECEFF',
  },
  fonts: {
    headings:
      "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    body: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    headingOne: '$body',
    headingTwo: '$body',
    headingThree: '$body',
    headingFour: '$body',
    subtitleOne: '$body',
    subtitleTwo: '$body',
    bodyOne: '$body',
    bodyOneSecondary: '$body',
    bodyTwo: '$body',
    bodyTwoSecondary: '$body',
    buttonOne: '$body',
    buttonTwo: '$body',
    label: '$body',
    overline: '$body',
    caption: '$body',
    tab: '$body',
  },
  fontWeights: {
    headingOne: 600,
    headingTwo: 600,
    headingThree: 600,
    headingFour: 600,
    subtitleOne: 700,
    subtitleTwo: 700,
    bodyOne: 400,
    bodyOneSecondary: 400,
    bodyTwo: 400,
    bodyTwoSecondary: 400,
    buttonOne: 600,
    buttonTwo: 600,
    label: 500,
    overline: 700,
    caption: 400,
    tab: 400,
  },
  letterSpacings: {
    headingOne: '0',
    headingTwo: '0',
    headingThree: '0',
    headingFour: '0',
    subtitleOne: '-0.20000000298023224px',
    subtitleTwo: '-0.20000000298023224px',
    bodyOne: '0',
    bodyOneSecondary: '$bodyOne',
    bodyTwo: '0',
    bodyTwoSecondary: '$bodyTwo',
    buttonOne: '-0.20000000298023224px',
    buttonTwo: '-0.20000000298023224px',
    label: '0',
    overline: '0.6000000238418579px',
    caption: '0',
    tab: '0',
  },
  textTransforms: {
    headingOne: 'none',
    headingTwo: 'none',
    headingThree: 'none',
    headingFour: 'none',
    subtitleOne: 'none',
    subtitleTwo: 'none',
    bodyOne: 'none',
    bodyOneSecondary: '$bodyOne',
    bodyTwo: 'none',
    bodyTwoSecondary: '$bodyTwo',
    buttonOne: 'none',
    buttonTwo: 'none',
    label: 'none',
    overline: 'uppercase',
    caption: 'none',
    tab: 'none',
  },
  textDecorations: {
    headingOne: 'none',
    headingTwo: 'none',
    headingThree: 'none',
    headingFour: 'none',
    subtitleOne: 'none',
    subtitleTwo: 'none',
    bodyOne: 'none',
    bodyOneSecondary: '$bodyOne',
    bodyTwo: 'none',
    bodyTwoSecondary: '$bodyTwo',
    buttonOne: 'none',
    buttonTwo: 'none',
    label: 'none',
    overline: 'none',
    caption: 'none',
    tab: 'none',
  },
  borderWidths: {
    thin: '1px',
    thick: '2px',
    outerFocus: '3px',
    innerFocus: '3px',
    card: '1px',
  },
  radii: {
    none: '0',
    thin: '1px',
    thick: '2px',
    small: '3px',
    medium: '6px',
    large: '9px',
    extraLarge: '12px',
    huge: '20px',
    circle: '99999px',
    pill: '99999px',
    button: '99999px',
    inputField: '6px',
    card: '6px',
    progressBar: '9999px',
    tags: '4px',
  },
  shadows: {
    card: '0px 0px 0px 0px #00000000',
    dropdown: '0px 4px 8px 0px #0000001A',
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4000,
    tooltip: 5000,
    modal: 8000,
    toast: 9000,
  },
  transitions: { defaultTime: '200ms' },
};

export const archetypeLightTheme: GDSTheme = {
  colors: {
    surface: {
      background: {
        primary: '#FFFFFFFF',
        secondary: '#F2F2F2FF',
        tertiary: '#E8E8E8FF',
      },
      card: {
        primary: '#F2F2F2FF',
        secondary: '#FFFFFFFF',
        disabled: '#D7D7D7FF',
      },
      screenHeader: { background: '#E8E8E8FF' },
      skeleton: {
        shimmer: {
          background: '#E7E7E7FF',
          overlay:
            'linear-gradient(90.0deg, #FFFFFF00 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)',
        },
      },
    },
    onSurface: {
      text: {
        primary: '#1A1A1AFF',
        subdued: '#545454FF',
        reversed: '#FFFFFFFF',
        critical: '#DD0E0EFF',
        success: '#507C03FF',
        warning: '#C94F08FF',
      },
      border: { subdued: '#EFEFEFFF', default: '#C2C2C2FF', card: '#EBEBEBFF' },
      icon: { primary: '#636363FF' },
    },
    interactive: {
      action: {
        primary: '#1A1A1AFF',
        hovered: '#000000FF',
        pressed: '#1A1A1AFF',
        subdued: '#66686BFF',
        disabled: '#D6D6D6FF',
      },
      icon: { default: '#FFFFFFFF', disabled: '#949494FF' },
      background: {
        default: '#FFFFFFFF',
        disabled: '#E8EAEDFF',
        hovered: '#F8F8F8FF',
        pressed: '#F0F0F0FF',
      },
      border: {
        default: '#949494FF',
        hovered: '#4E4E4EFF',
        disabled: '#D6D6D6FF',
        critical: { default: '#DD0E0EFF' },
      },
      focus: { inner: '#1A1A1AFF', outer: '#1A1A1AFF' },
    },
    critical: {
      background: { subdued: '#F9E1E2FF', secondary: '#FFFFFFFF' },
      border: { default: '#DD0E0EFF' },
      icon: '#DD0E0EFF',
    },
    warning: {
      background: { subdued: '#FAE8D6FF', secondary: '#FFFFFFFF' },
      border: { default: '#C94F08FF' },
      icon: '#C94F08FF',
    },
    success: {
      background: { subdued: '#F6FCEBFF', secondary: '#FFFFFFFF' },
      border: { default: '#507C03FF' },
      icon: '#507C03FF',
    },
    highlight: {
      background: { subdued: '#EDF8FFFF', secondary: '#FFFFFFFF' },
      border: { default: '#2E5CDFFF' },
      icon: '#2E5CDFFF',
    },
    decorative: {
      brand: {
        primary: {
          darkest: '#1A1A1AFF',
          dark: '#4B4B4BFF',
          default: '#7F7F7FFF',
          bright: '#B9B9B9FF',
          brightest: '#ECECECFF',
          pastel: '#FAFAFAFF',
        },
        secondary: {
          darkest: '#1A1A1AFF',
          dark: '#4B4B4BFF',
          default: '#7F7F7FFF',
          bright: '#B9B9B9FF',
          brightest: '#ECECECFF',
          pastel: '#FAFAFAFF',
        },
        tertiary: {
          darkest: '#1A1A1AFF',
          dark: '#4B4B4BFF',
          default: '#7F7F7FFF',
          bright: '#B9B9B9FF',
          brightest: '#ECECECFF',
          pastel: '#FAFAFAFF',
        },
      },
    },
    primary: {
      background: {
        default: '#1A1A1AFF',
        hovered: '#000000FF',
        pressed: '#1A1A1AFF',
        critical: {
          default: '#DD0E0EFF',
          hovered: '#B51414FF',
          pressed: '#DD0E0EFF',
        },
      },
      text: { default: '#FFFFFFFF', critical: { default: '#FFFFFFFF' } },
    },
    secondary: {
      background: {
        default: '#FFFFFFFF',
        hovered: '#DCDCDCFF',
        pressed: '#F0F0F0FF',
      },
      text: { default: '#1A1A1AFF', hovered: '#1A1A1AFF' },
      border: { default: '#1A1A1AFF' },
    },
    tertiary: {
      background: {
        default: '#FFFFFF00',
        hovered: '#DCDCDCFF',
        pressed: '#F0F0F0FF',
      },
      text: { default: '#1A1A1AFF', hovered: '#1A1A1AFF' },
      border: { default: '#DCDCDCFF' },
    },
    input: {
      border: {
        success: '#507C03FF',
        warning: '#C94F08FF',
        default: '#949494FF',
        hovered: '#4E4E4EFF',
        disabled: '#D6D6D6FF',
        critical: '#DD0E0EFF',
      },
      background: {
        default: '#FFFFFFFF',
        disabled: '#E8EAEDFF',
        hovered: '#F8F8F8FF',
        pressed: '#F0F0F0FF',
      },
    },
    dataViz: {
      interface: { track: { border: '#959595FF', background: '#F5F5F5FF' } },
      singleColor: { brand: '#1A1A1AFF', neutral: '#959595FF' },
      status: {
        critical: '#DD0E0EFF',
        warning: '#F16501FF',
        success: '#0DA80AFF',
      },
      categorical: {
        one: '#1A1A1AFF',
        two: '#6212E6FF',
        three: '#F0184CFF',
        four: '#2695E6FF',
        five: '#F16501FF',
        six: '#0DA80AFF',
      },
    },
    tag: {
      neutral: {
        background: { bold: '#3B3B3BFF', subdued: '#E9E9E9FF' },
        border: { bold: '#3B3B3BFF', subdued: '#E9E9E9FF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' },
      },
      one: {
        background: { bold: '#501CD2FF', subdued: '#EDEAF5FF' },
        border: { bold: '#501CD2FF', subdued: '#EDEAF5FF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' },
      },
      two: {
        background: { bold: '#135D03FF', subdued: '#DEEADCFF' },
        border: { bold: '#135D03FF', subdued: '#DEEADCFF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' },
      },
      three: {
        background: { bold: '#994000FF', subdued: '#F2EEE6FF' },
        border: { bold: '#994000FF', subdued: '#F2EEE6FF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' },
      },
      four: {
        background: { bold: '#870644FF', subdued: '#F2E1F0FF' },
        border: { bold: '#870644FF', subdued: '#F2E1F0FF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' },
      },
      success: {
        background: { bold: '#008A09FF', subdued: '#E3F7F0FF' },
        border: { bold: '#008A09FF', subdued: '#E3F7F0FF' },
        text: { bold: '#FFFFFFFF', subdued: '#02692BFF' },
      },
      warning: {
        background: { bold: '#B85B0FFF', subdued: '#FAE8D6FF' },
        border: { bold: '#B85B0FFF', subdued: '#FAE8D6FF' },
        text: { bold: '#FFFFFFFF', subdued: '#9F3703FF' },
      },
      critical: {
        background: { bold: '#DD0E0EFF', subdued: '#F9E1E2FF' },
        border: { bold: '#DD0E0EFF', subdued: '#F9E1E2FF' },
        text: { bold: '#FFFFFFFF', subdued: '#BB1111FF' },
      },
      informational: {
        background: { bold: '#2E5CDFFF', subdued: '#E8F8FFFF' },
        border: { bold: '#2E5CDFFF', subdued: '#E8F8FFFF' },
        text: { bold: '#FFFFFFFF', subdued: '#225ECEFF' },
      },
    },
  },
  shadows: {
    card: { x: 0, y: 0, blur: 0, spread: 0, color: '#00000000' },
    dropdown: { x: 0, y: 4, blur: 8, spread: 0, color: '#0000001A' },
  },
  typography: {
    headingOne: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 40,
      fontSize: 32,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingTwo: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 32,
      fontSize: 24,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingThree: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 28,
      fontSize: 20,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingFour: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 18,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    subtitleOne: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    subtitleTwo: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyOne: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyOneSecondary: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyTwo: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyTwoSecondary: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    buttonOne: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    buttonTwo: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    label: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    overline: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0.6000000238418579,
      paragraphSpacing: 0,
      textCase: 'uppercase',
      textDecoration: 'none',
    },
    caption: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    tab: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 12,
      fontSize: 10,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
  },
  spacing: {
    none: 0,
    eighth: 2,
    quarter: 4,
    half: 8,
    threeQuarters: 12,
    one: 16,
    oneAndHalf: 24,
    two: 32,
    twoAndHalf: 40,
    three: 48,
    four: 64,
    five: 80,
  },
  borderWidths: { thin: 1, thick: 2, outerFocus: 3, innerFocus: 3, card: 1 },
  borderRadii: {
    none: 0,
    thin: 1,
    thick: 2,
    small: 3,
    medium: 6,
    large: 9,
    extraLarge: 12,
    huge: 20,
    circle: 99999,
    pill: 99999,
    button: 99999,
    inputField: 6,
    card: 6,
    progressBar: 9999,
    tags: 4,
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4000,
    tooltip: 5000,
    modal: 8000,
    toast: 9000,
  },
  rem: {
    fontSizes: {
      headingOne: 2,
      headingTwo: 1.5,
      headingThree: 1.25,
      headingFour: 1.125,
      subtitleOne: 1,
      subtitleTwo: 0.875,
      bodyOne: 1,
      bodyOneSecondary: 1,
      bodyTwo: 0.875,
      bodyTwoSecondary: 0.875,
      buttonOne: 1,
      buttonTwo: 0.875,
      label: 0.75,
      overline: 0.75,
      caption: 0.75,
      tab: 0.625,
    },
    lineHeights: {
      headingOne: 2.5,
      headingTwo: 2,
      headingThree: 1.75,
      headingFour: 1.5,
      subtitleOne: 1.5,
      subtitleTwo: 1.25,
      bodyOne: 1.5,
      bodyOneSecondary: 1.5,
      bodyTwo: 1.25,
      bodyTwoSecondary: 1.25,
      buttonOne: 1.5,
      buttonTwo: 1.25,
      label: 1,
      overline: 1,
      caption: 1,
      tab: 0.75,
    },
    baseSize: 16,
  },
  fonts: {
    headings:
      "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    body: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  },
  transitions: { defaultTime: '200ms' },
};
